export default "__VITE_ASSET__IvYYcvAq__"